import React, { useEffect, useState } from "react";
import axios from "axios";
import API from "@/api";
import {Tag } from "antd";

function IndexStatus(props) {
  const { id } = props;
  const [status, setStatus] = useState("");
  useEffect(() => {
    if (id) {
      setTimeout(() => {
        axios.get(API.getIndexStatus + `?docid=${id}`).then((res) => {
          const data = res?.data?.result?.data || "";
          setStatus(data)
        });
      }, 100);
    }
  }, [id]);
  return <>{status ? <Tag color="success">成功</Tag> : <Tag color="error">失败</Tag>}</>;
}

export default IndexStatus;
